import { observer } from 'mobx-react'
import { Card, CardBody, CardHeader } from 'reactstrap'
import React from 'react'
import { observable, toJS } from 'mobx'
import Util from '../../common/Util'
import ApiClient, { ApiRoutes } from '../../api/ApiClient'
import { route } from '../../routes/routes'
import LoadingPanel from '../LoadingPanel'
import _ from 'lodash'

type GuestInvitationsData = {
  guestInvitationsCount: {
    day: number
    month: number
    year: number
  }
}

type Props = {
  filters: {
    state?: string
    areaId?: number
    chapterId?: number
  }
  onShowGuestList: (url: string, title: string) => void
}

@observer
export default class GuestInvitationsDashboard extends React.Component<Props> {
  @observable
  private guestInvitations?: GuestInvitationsData
  @observable
  private error?: string
  @observable
  private loading = false

  componentDidMount () {
    this.loadData().then()
  }

  componentDidUpdate (prevProps: Readonly<Props>, prevState: Readonly<{}>, snapshot?: any) {
    if (!_.isEqual(toJS(prevProps.filters), toJS(this.props.filters))) {
      this.loadData().then()
    }
  }

  private loadData = async () => {
    try {
      this.error = undefined
      this.loading = true

      const response = await ApiClient.getInstance().get(route(ApiRoutes.dashboard.guestInvitations, {}, this.props.filters))

      this.guestInvitations = response.data

      this.loading = false
    } catch (err) {
      this.error = Util.extractErrorMessage(err.response)
    }
  }

  render () {
    return <Card>
      <CardHeader>
        <b>Guest Invitations In Wired</b>
      </CardHeader>
      <CardBody>
        <LoadingPanel loading={this.loading} loaded={!!this.guestInvitations} error={this.error}>
          {
            this.guestInvitations
              ? <>
                <div className="d-flex">
                  <div className="flex-fill">
                    Today
                  </div>
                  <div className="text-right">
                    <a href="" onClick={ev => {
                      ev.preventDefault()
                      this.props.onShowGuestList(route(ApiRoutes.dashboard.guestInvitations, {}, {
                        ...this.props.filters,
                        list: 'day',
                      }), 'Guests Today')
                    }}>
                    {Util.formatNumber(this.guestInvitations!.guestInvitationsCount.day)}
                    </a>
                  </div>
                </div>
                <div className="d-flex">
                  <div className="flex-fill">
                    This Month
                  </div>
                  <div className="text-right">
                    <a href="" onClick={ev => {
                      ev.preventDefault()
                      this.props.onShowGuestList(route(ApiRoutes.dashboard.guestInvitations, {}, {
                        ...this.props.filters,
                        list: 'month',
                      }), 'Guests This Month')
                    }}>
                    {Util.formatNumber(this.guestInvitations!.guestInvitationsCount.month)}
                    </a>
                  </div>
                </div>
                <div className="d-flex">
                  <div className="flex-fill">
                    This Year
                  </div>
                  <div className="text-right">
                    <a href="" onClick={ev => {
                      ev.preventDefault()
                      this.props.onShowGuestList(route(ApiRoutes.dashboard.guestInvitations, {}, {
                        ...this.props.filters,
                        list: 'year',
                      }), 'Guests This Year')
                    }}>
                    {Util.formatNumber(this.guestInvitations!.guestInvitationsCount.year)}
                    </a>
                  </div>
                </div>
              </>
              : null
          }
        </LoadingPanel>
      </CardBody>
    </Card>
  }
}
